angular.
module("dx.webapp.lists").
controller("DxListPaginationController", function ListPaginationController() {
	"use strict";

	this.showPagination = function showPagination() {
		return this.itemCount > this.itemsPerPage;
	};

	this.getTotalPages = function getTotalPages() {
		return Math.ceil(this.itemCount / this.itemsPerPage);
	};

	this.prevPage = function prevPage() {
		if (this.currentPage > 0) {
			this.currentPage -= 1;
		}
	};

	this.nextPage = function nextPage() {
		if (this.currentPage < this.getTotalPages() - 1) {
			this.currentPage += 1;
		}
	};

	this.isFirstPage = function isFirstPage() {
		return this.currentPage === 0;
	};

	this.isLastPage = function isLastPage() {
		return this.currentPage === this.getTotalPages() - 1;
	};
});
